import { CategoryCard } from './CategoryCard';
import { shopByPopularCategories } from './PopularCategories';

export const RealEstate = () => {
  return (
    <CategoryCard
      image={shopByPopularCategories[3].image}
      description={shopByPopularCategories[3].desc}
      title={shopByPopularCategories[3].title}
      link={shopByPopularCategories[3].link}
      buttonText="RENT NOW"
      maxImageWidth="350px"
    />
  );
};
